import type {GetServerSideProps, GetServerSidePropsResult} from 'next';
import {
  type GetUserDataForAnalyticsResponseType,
  getUserDataForAnalytics,
} from '../../../core/repositories/usersMeRepository';
import {validateCookie} from '../../../core/usecases/auth/checkOauthTokenExistence';
import {GeneratePage} from '../../../features/aiEsBuilder/components/GeneratePage';
import {withHandler} from '../../../server/token/withHandler';
import {ScriptForGA} from '../../../shared/components/ScriptForGA';
import {EngineerPageLayout} from '../../../shared/components/layouts/EngineerPageLayout';
import type {NextPageWithLayout} from '../../_app';

type Props = {
  userDataForAnalytics?: GetUserDataForAnalyticsResponseType;
};

export const getServerSideProps: GetServerSideProps = withHandler<
  Props,
  'withOptionalSession'
>(
  {auth: 'optional'},
  async (context): Promise<GetServerSidePropsResult<Props>> => {
    const {cookies} = context.req;
    const {isValid} = validateCookie(cookies);
    if (!isValid) {
      // ログインしていない場合もこのセグメントを表示
      return {
        props: {},
      };
    }

    // ログインしているのにno-loginの場合はリダイレクト
    if (context.params?.id === 'no-login') {
      return {
        redirect: {
          permanent: false,
          destination: '/engineer/ai-es-builder',
        },
      };
    }

    const userDataResponse = await getUserDataForAnalytics({cookies});
    if (!userDataResponse.ok) {
      return {
        props: {},
      };
    }

    return {
      props: {
        userDataForAnalytics: userDataResponse.value,
      },
    };
  },
);

/**
 * 非ログインユーザーがESビルダーを生成した後、ログインさせて同じ結果を表示させるためのページ
 * index.tsxで生成した後、このページにリダイレクトされる
 * TODO: `GeneratePage`が表示するだけのユースケースも担当するのはToo muchなので、
 * 別途このページ専用のコンポーネントを用意する
 */
const Page: NextPageWithLayout = ({userDataForAnalytics}: Props) => {
  return (
    <>
      <GeneratePage />
      <ScriptForGA userDataForAnalytics={userDataForAnalytics} />
    </>
  );
};

export default Page;

Page.getLayout = (page) => (
  <EngineerPageLayout hasFooter={false}>{page}</EngineerPageLayout>
);
